import { camelCase as _camelCase } from "change-case";

export function capitalize(value: string) {
  return value.charAt(0).toUpperCase() + value.slice(1);
}

export function titleCase(value: string) {
  return value.split(" ").map(capitalize).join(" ");
}

export function kebabCase(s: string) {
  return s
    .replace(/([a-z])([A-Z])/g, "$1-$2")
    .replace(/[\s_]+/g, "-")
    .toLowerCase();
}

export function camelCase(s: string) {
  return _camelCase(s);
}

// Examples: pluralize(tacoCount, "taco"); pluralize(boxCount, "box", "boxes");
// Automatic "s" is for convenience in simple cases; when in doubt, supply the full plural noun
export function pluralize(count: number | unknown[], noun: string, pluralNoun?: string): string {
  if ((Array.isArray(count) ? count.length : count) === 1) return noun;
  return pluralNoun || `${noun}s`;
}

export function stripNumbers(s: string) {
  return s.replace(/\d+/g, "").trim();
}

/**
 * Cleans validation error messages by removing the "Validation error: CheckoutConfig:N" prefix
 * Example:
 * cleanValidationError("Validation error: CheckoutConfig:67 Garage Flooring Coating should be selected when Add Third Garage Bay is selected")
 * // Returns: "Garage Flooring Coating should be selected when Add Third Garage Bay is selected"
 */
export function cleanValidationError(errorMessage: string): string {
  const cleanErrorMessage = errorMessage.split("CheckoutConfig")[1]?.split(/[:#]/)[1];
  return cleanErrorMessage?.split(" ").slice(1).join(" ") || errorMessage;
}

/**
 * Temporary fix to remove "Pilot - " prefix from names (lot names, build names, etc.)
 * This should be removed once the backend data is cleaned up.
 * Example:
 * removePilotPrefix("Pilot - Main Street") // Returns: "Main Street"
 */
export function removePilotPrefix(name: string | null | undefined): string {
  if (!name) return "";
  return name.replace("Pilot - ", "");
}

export function isValidEmail(email: string | null | undefined): boolean {
  if (!email) return false;
  const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return EMAIL_REGEX.test(email.trim());
}

/**
 * Validates phone number - must be exactly 10 digits (no formatting)
 * Optional fields (empty string, null, undefined) are considered valid
 */
export function isValidPhone(phone: string | null | undefined): boolean {
  if (!phone) return true; // Optional field
  const digitsOnly = phone.replace(/\D/g, ""); // Remove all non-digit characters
  return digitsOnly.length === 10;
}
